import cryptographix from "../assets/projectsimages/cryptographix.png";
import learnlogics from "../assets/projectsimages/learnlogics.png"
import bmdevelopers from "../assets/projectsimages/bmdevelopers.png";
import microsoft from "../assets/projectsimages/microsoft.png";
import deependraparmar from "../assets/projectsimages/deependraparmar.png";
import awesomeui from "../assets/projectsimages/awesomeui.png";
import airiq from "../assets/projectsimages/airiq.png";
import gamingninja from "../assets/projectsimages/gamingninja.png";
import whatstheweather from "../assets/projectsimages/whatstheweather.png";
import wordx from "../assets/projectsimages/wordx.png";


export const projects = [
    {
        title: "Deependra Parmar",
        description: "This is my personal favorite portfolio website. I have created this website to showcase my skills,projects & more.",
        url: "https://deependraparmar.vercel.app",
        img: deependraparmar,
        technologies: [
            "ReactJS",
            "Sass",
            "Firebase",
            "Vercel"
        ],
        githuburl: "https://www.github.com/DeependraParmar/DeependraParmarPortfolio"
    },
    {
        title: "BM Developers",
        description: "BM Developers are one of the best Web and Software Development Company in India, expertise in IT Services.",
        url: "https://bmdevelopers.netlify.app",
        img: bmdevelopers,
        technologies: [
            "ReactJS",
            "Sass",
            "Chakra UI",
            "Netlify"
        ],
        githuburl: "https://www.github.com/DeependraParmar/BM-Developers"
    },
    {
        title: "Microsoft Clone",
        description: "Microsoft and its UI is among the best in the world. So, I tried to clone the Microsoft website using TailwindCSS.",
        url: "https://microsoftbydp.netlify.app",
        img: microsoft,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "TailwindCSS",
            "Netlify"
        ],
        githuburl: "https://www.github.com/DeependraParmar/Microsoft-Clone"
    },
    {
        title: "CryptoGraphix",
        description: "Dynamic Web App capable of fetching Realtime Data and Visualizing the data using Graphs and Charts.",
        url: "https://cryptographix.vercel.app",
        img: cryptographix,
        technologies: [
            "ReactJS",
            "Sass",
            "Chakra UI",
            "Chart.js",
            "Axios",
            "CoinGecko API",
            "Vercel"
        ],
        githuburl: "https://www.github.com/DeependraParmar/CryptoGraphix"
    },
    {
        title: "Learn Logics",
        description: "Learn Logics is for the students to learn programming languages and want to learn about the latest techs.",
        url: "https://learnlogics.github.io",
        img: learnlogics,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "NodeJS",
            "ExpressJS",
            "MongoDB",
            "Github Pages"
        ],
        githuburl: "https://www.github.com/DeependraParmar/LearnLogics"
    },
    {
        title: "AwesomeUI",
        description: "AwesomeUI is a UI Library for ReactJS. It is a collection of UI Components which are used in almost every website.",
        url: "https://awesomeuibydp.netlify.app",
        img: awesomeui,
        technologies: [
            "HTML",
            "CSS",
            "ReactJS",
            "TailwindCSS",
            "JavaScript",
            "Netlify"
        ],
        githuburl: "https://www.github.com/DeependraParmar/AwesomeUi"
    },
    {
        title: "AirIQ",
        description: "AirIQ is a website which is used to check the quality of air in your area. It uses our own IOT device to fetch the data.",
        url: "https://www.airiq.us",
        img: airiq,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "ReactJS",
            "TailwindCSS",
            "Replit",
            "NodeJS",
            "ExpressJS",
            "CochroachDB",
            "DigitalOcean"
        ],
        githuburl: "https://www.github.com/DeependraParmar/AirIQ-Wittyhacks"
    },
    {
        title: "Gaming Ninja",
        description: "Gaming Ninja is UI website created for pro gamers. It basically shows the latest games and their reviews.",
        url: "https://gamingninja.vercel.app",
        img: gamingninja,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "ReactJS",
            "Chakra UI",
        ],
        githuburl: "https://www.github.com/DeependraParmar/GamingNinja"
    },
    {
        title: "WordX",
        description: "WordX is a text formatting website provides you with the best tools to format your text in the best way possible.",
        url: "https://wordxbydp.netlify.app",
        img: wordx,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "ReactJS"
        ],
        githuburl: "https://www.github.com/DeependraParmar/WordX"
    },
    {
        title: "What's The Weather",
        description: "Whats's The Weather is a website which is used to check the accureate realtime weather of any city in the world.",
        url: "https://whatstheweatherbydp.netlify.app",
        img: whatstheweather,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "ReactJS",
            "Bootstrap",
            "Rapid API"
        ],
        githuburl: "https://www.github.com/DeependraParmar/What-s-The-Weather"
    }
]
